import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHashtag32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconHashtag32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.847 6.141a1 1 0 0 0-1.98-.283L12.133 11H7.429a1 1 0 1 0 0 2h4.418l-.857 6H6a1 1 0 1 0 0 2h4.704l-.694 4.858a1 1 0 1 0 1.98.283L12.724 21h5.123l-.694 4.858a1 1 0 1 0 1.98.283L19.867 21h4.704a1 1 0 1 0 0-2h-4.418l.857-6H26a1 1 0 1 0 0-2h-4.704l.694-4.859a1 1 0 0 0-1.98-.283L19.276 11h-5.123zM13.867 13l-.857 6h5.123l.857-6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHashtag32);
